import { Box, FormHelperText, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import React, { memo } from 'react';
import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';
import { countries } from '../../constants';
import type { ChangeBillingAddressPayload } from './BillingAddressForm';

interface BillingAddressCountrySelectProps {
	control: Control<ChangeBillingAddressPayload>;
	errors: any;
	labelText: string;
	placeholder: string;
}

const BillingAddressCountrySelect = ({
	control,
	errors,
	labelText,
	placeholder,
}: BillingAddressCountrySelectProps) => {
	const { t } = useTranslation();

	return (
		<Box>
			<FormLabel sx={{ color: 'text.primary' }}>{labelText}</FormLabel>
			<Controller
				name="country"
				control={control}
				as={
					<Select
						error={!!errors.country}
						sx={{
							width: '100%',
							height: '40px',
							borderRadius: borderRadius.sm,
							border: `1px solid ${palette.components.input.outlined.enabledBorder}`,
							p: 0,
						}}
						displayEmpty // For show placeholder
					>
						<MenuItem
							key={'placeholder'}
							disabled
							value="" // Empty value for placeholder
						>
							<Typography
								sx={{
									fontStyle: 'normal',
									color: palette.text.disabled,
								}}
							>
								{t(placeholder)}
							</Typography>
						</MenuItem>
						{countries &&
							Object.entries(countries).map(([code, name]) => (
								<MenuItem key={code} value={name}>
									{name}
								</MenuItem>
							))}
					</Select>
				}
			/>
			{!!errors.country && (
				<FormHelperText
					sx={{
						paddingLeft: spaces.sm,
						color: palette.error.main,
					}}
				>
					{t(errors.country.message)}
				</FormHelperText>
			)}
		</Box>
	);
};

export default memo(BillingAddressCountrySelect);
